import React from "react";

import { StyledIntro } from "./Styled.intro";
import AnimatedCharacters from "./Styled.animate";

import { motion } from "framer-motion";
import ReactLoading from "react-loading";

function Intro() {
  const placeholderText = [
    { type: "heading1", text: "Praiz_DcoDer" },
    // {type: "heading2", text: "Presents"},
    // {type: "heading3", text: "Another Banger"},
  ];

  const container = {
    visible: {
      transition: {
        staggerChildren: 0.06,
      },
    },
  };

  const delayPresents = {
    initial: { opacity: 0 },
    visible: {
      opacity: 1,
      color: "#2BC6DE",
      transition: {
        delay: 1.5,
        type: "spring",
        damping: 3,
        stiffness: 50,
        bounce: 0.25,
        restDelta: 0.001,
      },
    },
  };

  const delayBanger = {
    initial: { opacity: 0, scale: 1.5 },
    visible: {
      opacity: 1,
      scale: [1, 1.5, 1, 1.5, 1],
      transition: {
        delay: 3,
        type: "spring",
        damping: 3,
        stiffness: 50,
        ease: "linear",
        duration: 1.5,
        bounce: 0.25,
        restDelta: 0.001,
      },
    },
  };
  return (
    <motion.div
      // className="App"
      initial="hidden"
      animate="visible"
      // animate={replay ? "visible" : "hidden"}
      variants={container}
    >
      <StyledIntro>
        <div className="container">
          {placeholderText.map((item, index) => {
            return <AnimatedCharacters {...item} key={index} />;
          })}
          <motion.div
            initial="initial"
            animate="visible"
            variants={delayPresents}
          >
            {" "}
            Presents
          </motion.div>
          <motion.div
            initial="initial"
            animate="visible"
            variants={delayBanger}
          >
            {" "}
            Another Banger
          </motion.div>

          <div>
            <ReactLoading
              type="bubbles"
              color="#2BC6DE"
              height="5rem"
              width="5rem"
            />
          </div>
        </div>
      </StyledIntro>
    </motion.div>
  );
}

export default Intro;
